export default __webpack_public_path__ + "static/media/arrivchart.e13cc087.svg";